module.exports = __webpack_public_path__ + "img/setting.24440e37.svg";